import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const accessTokenJSON = localStorage.getItem('auth');

import initialConfig from '../initialConfig';

const initialState: {
  userRateListingMutationData: any;
  userRateListingMutationLoading: boolean;
  userRateListingMutationError: SerializedError | null;
} = {
  userRateListingMutationData: {},
  userRateListingMutationLoading: false,
  userRateListingMutationError: null,
};

export const userRateListingMutationFunc = createAsyncThunk(
  'userRateListingMutation/userRateListingMutationFunc',
  async (values: {
    rateListingInput: {
      listingId: string;
      rating: number;
      comment: string;
    };
  }) => {
    const data1 = JSON.stringify({
      query: `mutation UserRateListing($rateListingInput: RateListingInput!) {
        user_rateListing(rateListingInput: $rateListingInput) {
            average
            createdAt
            numberOfReviews
            updatedAt
        }
    }`,
      variables: {
        rateListingInput: {
          listingId: values?.rateListingInput?.listingId ?? null,
          rating: values?.rateListingInput?.rating ?? null,
          comment: values?.rateListingInput?.comment ?? null,
        },
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const userRateListingMutation = createSlice({
  name: 'userRateListingMutation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userRateListingMutationFunc.pending, (state) => {
      state.userRateListingMutationLoading = true;
    });
    builder.addCase(userRateListingMutationFunc.fulfilled, (state, action) => {
      state.userRateListingMutationLoading = false;
      state.userRateListingMutationData = action.payload?.data?.userRateListingMutation;
      state.userRateListingMutationError =
        action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(userRateListingMutationFunc.rejected, (state, action) => {
      state.userRateListingMutationLoading = false;
      state.userRateListingMutationError = action.error;
    });
  },
});

export default userRateListingMutation.reducer;
